/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */

import {
  DateField,
  ExperimentalFormRow,
  TextField,
  type DateFieldState,
  type TextFieldState,
} from "@superweb/ui";

import { useMessage } from "#internal/intl";
import { useValidate } from "#internal/utils";

export type DriverLicenseDetailsState = {
  number: TextFieldState;
  issue_date: DateFieldState;
  expiry_date: DateFieldState;
};

export const DriverLicenseDetailsFields = ({
  state,
  onChangePartial,
  countryCode,
}: {
  state: DriverLicenseDetailsState;
  onChangePartial: (
    partialNextState: Partial<DriverLicenseDetailsState>,
  ) => void;
  countryCode: string;
}) => {
  const message = useMessage();

  const { validateTextField, validateDateField } = useValidate();

  return (
    <>
      <TextField
        required
        label={
          countryCode === "RU"
            ? message({
                id: "64d8cf10-7909-442f-b071-02b0c3d39424",
                context: "Yango forms. Driver license",
                default: "Driver's license series and number",
              })
            : message({
                id: "9af5b9d9-349e-4349-a008-281706c24270",
                context: "Yango forms. Driver license",
                default: "Driver's license number",
              })
        }
        state={state.number}
        onChange={(newState) => {
          const errorMessage = validateTextField(newState.value);
          onChangePartial({
            number: {
              ...newState,
              errorMessage,
              errorVisible: !!errorMessage,
            },
          });
        }}
      />
      <ExperimentalFormRow columnsCount={2}>
        <DateField
          label={message({
            id: "02d879f9-1327-46de-acb2-81eee55f38f5",
            context: "Yango forms. Date of issue",
            default: "Issue date",
          })}
          state={state.issue_date}
          onChange={(newState) => {
            const errorMessage = validateDateField(newState.value);
            onChangePartial({
              issue_date: {
                ...newState,
                errorMessage,
                errorVisible: !!errorMessage,
              },
            });
          }}
        />
        <DateField
          label={message({
            id: "776ba0e3-99e1-43be-ae7a-138b89219812",
            context: "Yango forms. Date of expire",
            default: "Expiration date",
          })}
          state={state.expiry_date}
          onChange={(newState) => {
            const errorMessage = validateDateField(newState.value);
            onChangePartial({
              expiry_date: {
                ...newState,
                errorMessage,
                errorVisible: !!errorMessage,
              },
            });
          }}
        />
      </ExperimentalFormRow>
    </>
  );
};
